import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getRouteApi } from '@tanstack/react-router';
import { AGGREGATE_NAMES, LOAN_REQUEST_COMMANDS } from 'cpool-constants';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { APICommunicator } from '~/api/APICommunicator';
import useLead from '~/features/leadDetails/hooks/useLead';
import { queryKeys } from '~/utils/queryKeys';

type Options = {
    onSuccess?: () => void;
};

export const useResetConsorsNotesFlagMutation = (loanRequestId: string, options: Options = {}) => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const queryKey = queryKeys.getConsorsNotesByLeadId(loanRequestId);
    const { useParams } = getRouteApi('/_app/leads_/details/$leadId');
    const { leadId } = useParams();
    const { data: lead } = useLead(leadId);
    const subscriptionIdentifier = lead?.consors?.subscriptionIdentifier;
    return useMutation({
        mutationFn: async () => {
            return APICommunicator.sendCommand({
                aggregateId: loanRequestId,
                aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
                commandName: LOAN_REQUEST_COMMANDS.resetConsorsNotesFlag,
                payload: {
                    loanRequestId,
                    subscriptionIdentifier,
                },
            });
        },
        onError: () => {
            toast.error(t('CONSORS_NOTES.TOASTS.RESET_CONSORS_NOTES_FLAG_FAILED'));
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey });
            options.onSuccess?.();
        },
    });
};
